export const REQUEST_OTP = 'REQUEST_OTP';
export const REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS'
export const REQUEST_OTP_ERROR = 'REQUEST_OTP_ERROR';
export const SEND_OTP = 'SEND_OTP';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_ERROR = 'SEND_OTP_ERROR';
export const FETCH_OTP_STATE = 'FETCH_OTP_STATE';
export const FETCH_STATE_SUCCESS = 'FETCH_STATE_SUCCESS';
export const FETCH_STATE_ERROR = 'FETCH_STATE_ERROR';
export const REQUIRE_RESEND = 'REQUIRE_RESEND';
export const CLEAR_ERROR = 'CLEAR_ERROR';
